/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type Wave1IconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function Wave1Icon(props: Wave1IconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 715 214"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fill={"currentColor"}
        d={
          "m0 42.8 10.824 24.944c10.825 25.212 32.374 74.7 54.221 82.056 21.6 7.356 43.198-28.756 65.045-39.256 21.599-10.9 43.198 3.812 65.045 7.156 21.55 3.344 43.198-3.344 65.046-21.4 21.499-18.056 43.197-46.144 65.045-57.044 21.45-10.5 43.198-3.812 64.548 21.4 21.897 24.944 43.695 67.744 65.045 74.9 21.848 6.888 43.695-21.2 65.046-46.412C541.662 64.2 563.559 42.8 584.91 49.956c21.748 6.888 43.198 43 65.045 46.344 21.698 3.344 43.198-24.744 54.121-39.256L715 42.8V214H0z"
        }
      ></path>
    </svg>
  );
}

export default Wave1Icon;
/* prettier-ignore-end */
